import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SafeUrl} from '@angular/platform-browser';
import {ConfigService} from '../config/config.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
    selector: 'occupational-profile-orientation',
    templateUrl: './occupational-profile-orientation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OccupationalProfileOrientationComponent {

    @Input()
    public occupationalProfileTitle?: string;
    public orienationtestUrlObservable: Observable<SafeUrl>;

    constructor(private configService: ConfigService) {
		this.orienationtestUrlObservable = this.getOrientationtestUrlObservable();
    }

    getOrientationtestUrlObservable(): Observable<SafeUrl> {
        return this.configService.getConfig()
            .pipe(map(config => config.orientationtestUrl));
    }
}
